module.exports = __webpack_public_path__ + "static/media/Azra.b46257f7.jpeg";